import { render } from "./TheNotificationArea.vue?vue&type=template&id=48544a44&scoped=true&ts=true"
import script from "./TheNotificationArea.vue?vue&type=script&lang=ts"
export * from "./TheNotificationArea.vue?vue&type=script&lang=ts"

import "./TheNotificationArea.vue?vue&type=style&index=0&id=48544a44&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48544a44"]])

export default __exports__